export const API_URL = `${process.env.VUE_APP_ROOT_API}/api/externalapi/`;
export const POSTCODE_API_URL = `${process.env.VUE_APP_ROOT_API}/Postcode/PostcodeLookup`;
export default API_URL;